import {gh} from '../general/general-helpers';

(function ($) {
    if ( document.body.classList.contains('page-template-fpga-landing') ) {
        $('.offcanvas a').click(function (event) {
            $('#close-mobile-menu').trigger('click');
            if ($.attr(this, 'href') !== '#') {

                $('html, body').animate(
                    {
                        scrollTop: $($.attr(this, 'href')).offset().top + -60,
                    },
                    500
                );
            }
        });

        $('header, main').on('click', 'a[href^="#"]', function (event) {
            if ($.attr(this, 'href') !== '#') {
                $('html, body').animate(
                    {
                        scrollTop: $($.attr(this, 'href')).offset().top + -80,
                    },
                    500
                );
            }
        });

        $(window).scroll(function () {
            if (window.scrollY > 40) {
                $('.header__nav').addClass('nav-active');
            } else {
                $('.header__nav').removeClass('nav-active');
            }
        });

        /*==================================================================
        ▐	2. FPGA pop-up (modal)
        ===================================================================*/

        /* Prevent form submission in CF7 forms if required fields are empty (frontend validation)
		-------------------------------------------------------------------*/
        gh.initCF7FrontendValidation();

        /* Show FPGA pop-up
		-------------------------------------------------------------------*/
        document.getElementById( 'fpga-modal-link' ).click();
    }
})(jQuery);
